import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";


const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};


export const ExternoMenu = ({ solicitud }) => {

  return (
    <React.Fragment>
    <Typography
      variant="h6"
      style={{
        textDecoration: "underline",
        textAlign: "center",
        margin: "1.5rem 0",
      }}
    >
      Información
    </Typography>
    <Table style={{ width: "80%", margin: "auto" }}>
      <TableBody>
        <TableRow>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            Razon Social: 
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            {solicitud?.nombre}
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            CUIL / CUIT:
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            {solicitud?.cuit}
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            Correo electrónico:
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            {solicitud?.email}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            Teléfono:
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            {solicitud?.telefono}
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            Celular:
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            {solicitud?.celular}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            Fecha de carga:
          </TableCell>
          <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            {new Date(solicitud?.fechaCarga).toLocaleString(
              "es",
              optionsfecha
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </React.Fragment>
  )
}
